// NOTE: Dependencies: jQuery, Defiant

(function ($) {
	$.fn.lmPredictiveSearch = function(options) {

		const $context = $(this);

		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			activeClass: 'predictive-search--active',
			bodyClass: 'site-overlay site-overlay--no-bg',
			$siteOverlayItem: $('.site-overlay__item'),
			loaderClass: 'loader',
			$languageSelectorToggle: $('.language-selector--mega-dropdown .language-selector__toggle'),
			languageSelectorToggleActive: 'language-selector__toggle--active',
			$languageSelectorDropdown: $('.language-selector__dropdown'),
			languageSelectorDropdownActive: 'language-selector__dropdown--active'
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$form = $context.closest('form');
			settings.$loader = settings.$form.parent();
			settings.$predictiveInput = settings.$form.find('.search-bar__input--predictive');
		};

		// Toggle Active Classes
		methods.toggle = function () {
			$context.toggleClass(settings.activeClass);
		};

		// Bind events
		methods.events = function() {
			var timer;

			$(document.body).off('click.lmPredictiveSearch').on('click.lmPredictiveSearch', '[data-product-id]', function(event) {
				event.preventDefault();
				var $productItem = $(this),
					productId = $productItem.attr('data-product-id'),
					$productParentInput = $productItem.closest('.search-bar__container').find('.search-bar__input--predictive');

				settings.$body.removeClass(settings.bodyClass);
				$context.removeClass(settings.activeClass);
				$productParentInput.val(productId);
			});

			// Event for predictive text on input
			settings.$predictiveInput.on('input.lmPredictiveSearch', function(event) {
				event.preventDefault();

				var $this = $(this),
					$panel = $this.parent().find('.predictive-search');

				settings.ajaxUrl = $panel.attr('data-ajax-url');

				// Setting global value to be used in multiple functions
				settings.searchValue = this.value;

				//Remove language selector
				settings.$languageSelectorToggle.removeClass(settings.languageSelectorToggleActive);
				settings.$languageSelectorDropdown.removeClass(settings.languageSelectorDropdownActive);

				// Only runs above 4 characters and on non touch devices as keyboard will probably get in way of predictive panel
				if (settings.searchValue.length > 1) {
					
					// Add loader
					settings.$loader.addClass(settings.loaderClass);

					// Timer used for delay on predictive search so ajax calls aren't running continuously
					clearTimeout(timer);
					timer = setTimeout(function() {

						// Displaying panel
						$panel.addClass(settings.activeClass);

						// Add body overlay
						// Commenting body class overlay for time being as is quite buggy and I don't think is necessary
						settings.$body.addClass(settings.bodyClass);

						// Remove language selector
						settings.$languageSelectorToggle.removeClass(settings.languageSelectorToggleActive);
						settings.$languageSelectorDropdown.removeClass(settings.languageSelectorDropdownActive);

						// Ajax Call here. BED to do.
						methods.ajaxCall();

					}, 500);
				} else {

					// Remove loader
					settings.$loader.removeClass(settings.loaderClass);

					// Removing panel
					$panel.removeClass(settings.activeClass);

					// Removing body class
					// Commenting body class overlay for time being as is quite buggy and I don't think is necessary
					settings.$body.removeClass(settings.bodyClass);
					
				}
			});
		};

		// Empty function thats not called at the moment. Leaving until discussed with BED

		methods.ajaxCall = function() {

			var data = {
				mode: 'ajax',
				q: settings.searchValue
			}
			
			// Initial ajax call. Only calls once. Else uses stored variable snapshot using Defiant JS.
			if (!settings.dataSnapShot) {
				$.ajax({
					type: 'GET',
					data: data,
					dataType: 'html',
					url: settings.ajaxUrl,
					success: function(data) {
						$('.predictive-search').html(data);
						settings.$loader.removeClass(settings.loaderClass);
					}
				});
			} else {
				// Leaving blank until now how works with BED
			}
		};

		// On load function.
		methods.initContext = function () {
			methods.setCurrentSettings();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});
		
	};

	if($('.predictive-search').length) {
		if ($('html').hasClass('is-desktop')) {
			$('.predictive-search').lmPredictiveSearch();
		}
	}

}(jQuery));